export type CALLBACK = (peers: ParticipantType[]) => ParticipantType[];

export interface ServiceType {
  openShare: () => void; // 桌面共享
  openElectronShare: (shareStream: MediaStream) => void; //electron桌面共享
  closeElectronShare: () => void; //关闭electron共享
  stopLocalPreview: () => void; // 关闭本地视频
  startLocalPreview: () => void; // 打开本地视频
  startRemoteVideo: (userId: string) => void; //拉取远端视频
  stopRemoteVideo: (userId: string) => void; // 关闭远端视频
  setParticipantInActivePage: (userId: string, bInActivePage: boolean) => void; // 设置参会人是否在当前页
  updateParticipants: () => void;
  switchToSpeakerView: () => void; // 切换到演讲者视图
  switchToOtherView: () => void; // 切换到其他视图
  muteLocalVideo: () => void; // 暂停本地视频
  unMuteLocalVideo: () => void; // 恢复本地视频
  stopLocalAudio: () => void; // 关闭本地音频
  startLocalAudio: () => void; // 打开本地音频
  muteLocalAudio: (mute: boolean) => void; // 静音/恢复
  muteAllRemoteAudios: () => void; // 暂停所有音频
  unMuteAllRemoteAudios: () => void; // 恢复所有音频
  muteAllRemoteViews: () => void; // 暂停所有视频
  unMuteAllRemoteViews: () => void; // 恢复所有视频
  pin: (userId: string, pinned: boolean) => void; // 固定/取消固定视频
  setParticipants: (cb: CALLBACK) => void; // 设置参会人状态
  close: () => void; // 关闭
  sendCustomCmdMsg: (d: any) => void;
  setAudioPlayoutVolume: (v: number) => void;
  setCurrentMic: (v: string) => void;
  setCurrentCameraDevice: (v: string) => void;
  setCurrentSpeaker: (v: string) => void;
  openMic: () => void;
  closeMic: () => void;
}

export enum RoleCode {
  //0 游客，10 联席主持人， 20 主持人
  host = 20,
  cohost = 10,
  guest = 0,
}

export interface ParticipantType {
  peerId: string;
  peerName?: string;
  roleCode?: RoleCode;
  isHost?: boolean;
  raiseHandStatus?: boolean;
  recordStatus?: boolean;
  local?: boolean;
  share?: boolean;
  active?: boolean;
  audio?: boolean;
  speaker?: boolean;
  video?: boolean;
  pinned?: boolean;
  recording?: boolean; //recording or not
  recordingPaused?:boolean; //recording is paused or not
  livestreaming?:boolean; // is livesteaming or not
  isLiveStreamingPaused?:boolean;
  //added by pcg should manipulate video audio tag at Layout
  videoTrack?: MediaStreamTrack; //can also include shareTrack
  audioTrack?: MediaStreamTrack;
  bInActivePage?: boolean;
  sosPressed?: boolean;
}

export interface RtcType {
  //board: any;
  participants: ParticipantType[];
  service: ServiceType;
  conference: ConferenceInterface;
  updateConference: (c: ConferenceInterface) => void;
  setParticipants: (cb: CALLBACK) => void;
 
}
////////////////////////////////////////////////////////

export interface AnyType {
  [k: string]: any;
}

export enum ResponseCode {
  success = 200,
  unauthorized = 401,
}

export enum JoinMeetingInterrupt {
  none = 60000,
  joinException = 60001, //加入会议异常
  conferenceNoNotExist = 60002, //会议号不存在
  meetingCanceled = 60003, //该会议已取消
  meetingLocked = 60004, //会议已锁定，如需加入请联系主持人
  meetingPrecedeEnterNotAllowed = 60005, //请等待主持人开始当前会议
  passwordNeeded = 60006, //请输入会议密码
  quickMeetingEnded = 60007, //及时会议已结束
  preservedMeetingEnded = 60008, //会议己结束,针对预约会议结束的提示
  attendFull = 60009, //会议人数已满，如需加入请联系主持人
  hasMeetingInProgress = 60010, //是否结束当前正在进行中的会议    （1）只针对owner的提示 （2）服务端返回正在召开会议信息 ，端上决定是否关闭（3）调用关闭会议接口 YMC0022
  hostInAnotherMeeting = 60011, //主持人正在开另外一场会议    （1）针对非owner的提示 （2）服务端返回会议信息，提示只显示会议号
  wrongPassword = 60012, //会议密码输入错误，请重新输入
  roomNotExist = 60013, //会议房间信息不存在 针对向auth申请token时校验
  rtcTokenExpired = 60034, //rtc token已经失效或者不存在
  tokenDifferWithRtc = 60035 //token 与 rtc 的token不一致
}

export interface ResponseType {
  code: ResponseCode | number;
  data?: AnyType;
  msg?: string;
}

export enum PlatformEnum {
  android = "android",
  iOS = "iOS",
  windows = "windows",
  mac = "mac",
}

export enum MethodEmun {
  post = "post",
  get = "get",
  put = "put",
  delete = "delete",
}
export enum Commond {
  // v1.0
 
  lockConference = "lockConference", //锁定会议
  unLockConference = "unLockConference", //解锁会议
  endConference = "endConference", //结束会议
  raiseHand = "raiseHand", //举手
  singleHandsDown = "singleHandsDown", //单个成员手放下
  allHandsDown = "allHandsDown", //全部停止举手
  singleMute = "singleMute", //单个静音
  singleUnMute = "singleUnMute", //单个解除静音
  allForceMute = "allForceMute", // 全体强制静音:
  allUnForceMute = "allUnForceMute", // 全体非强制静音:
  allUnMute = "allUnMute", // 全体解除静音
  changeNameByHost = "changeNameByHost", // 更改参会人名字(被主持人改) changeNameByHost  [userName]
  removeUser = "removeUser", // 移除参会人 removeUser
  recoverHostPermission = "recoverHostPermission", // 收回主持人权限 recoverHostPermission
  applyHostPermission = "applyHostPermission", // 申请主持人权限 applyHostPermission [ownerPassword]
  stopShare = "stopShare", // 停止共享 stopShare
  shieldVideos = "shieldVideos", // 屏蔽参会人视频 shieldVideos
  openVideos = "openVideos", // 请求打开参会人视频 openVideos
  startRecord = "startRecord", // 参会人开始录制 startRecord
  stopRecord = "stopRecord", // 停止参会人录制 stopRecord
  sharePermissionsForAll = "sharePermissionsForAll", // 更改会议共享权限（所有人可共享） sharePermissionsForAll
  sharePermissionsForHost = "sharePermissionsForHost", // 更改会议共享权限（仅主持人可共享） sharePermissionsForHost
  recordPermissionForAll = "recordPermissionForAll", // 更改会议录制权限(所有人可录制) recordPermissionForAll
  recordPermissionForHost = "recordPermissionForHost", // 更改会议录制权限(仅主持人可录制) recordPermissionForHost
  settingAgendaPermissionForAll = "settingAgendaPermissionForAll", // 会议议程权限设置(所有人可见) settingAgendaPermissionForAll
  settingAgendaPermissionForHost = "settingAgendaPermissionForHost", // 会议议程权限设置(仅主持人可见)
  grant = "grant", // 授权(角色变更) grant [roleCode]   游客 0   联席主持⼈ 10    主持⼈ 20
  transferHost = "transferHost", // 转移主持人
  
  openMuteJoinMeeting = "openMuteJoinMeeting", // 成员加入会议开启静音 openMuteJoinMeeting
  closeMuteJoinMeeting = "closeMuteJoinMeeting", // 成员加入会议关闭静音 closeMuteJoinMeeting
  openPlayTips = "openPlayTips", // 成员加入会议时开启播放提示音 openPlayTips
  closePlayTips = "closePlayTips", // 成员加入会议时关闭播放提示音 closePlayTips
  allowSelfUnmute = "allowSelfUnmute", // 允许成员自我解除静音: allowSelfUnmute
  forbidSelfUnmute = "forbidSelfUnmute", // 禁止成员自我解除静音: forbidSelfUnmute

  pauseRecording = "pauseRecording", // 暂停录制 pauseRecording
  resumeRecording = "resumeRecording", // 恢复录制 resumeRecording

  removeSelf = "removeSelf", // 剔除自己（两个设备进入同一个会议）
  forceEndConference = "forceEndConference", // 强制结束会议  forceEndConference（RTC无需调用auth验证权限）
  hostLeave="hostLeave", // 主持人离开会议
  hostLeaveMeeting = "hostLeaveMeeting", // 主持人离开会议 hostLeaveMeeting （RTC无需调用auth验证权限）
  automaticGrant = "automaticGrant", // 自动选举主持人 automaticGrant （RTC无需调用auth验证权限）
  hostJoinRoom = "hostJoinRoom", // 主持人加入会议 hostJoinRoom （RTC无需调用auth验证权限）
  maturityNotice = "maturityNotice", //免费会议结束前10分钟通知  （服务端发起）

  startStreaming = "startStreaming", // 参会人开始推流 startStreaming
  stopStreaming = "stopStreaming", // 参会人停止推流 stopStreaming
  pauseStreaming = "pauseStreaming", // 参会人暂停推流 pauseStreaming
  resumeStreaming = "resumeStreaming", // 参会人继续推流 resumeStreaming
  
}

export const MeetingStatusTxtMap: AnyType = {
  "0": "未开始",
  "10": "进行中",
  "20": "已结束",
  "30": "已取消",
  "40": "已过期",
  "50": "已失效",
};

export enum BoolType {
  yes = 1,
  no = 0,
}

export enum ConfefenctType {
  appointment = 1,
  immediate = 2,
}
export enum ConferenctStatusEnum {
  notStarted = 0,
  ongoing = 10,
  finished = 20,
  canceled = 30,
  expire = 40,
  invalid = 50,
}

export const getConferenceStatusCN = (a: ConferenctStatusEnum) => {
  switch (a) {
    case ConferenctStatusEnum.notStarted:
      return "未开始";
    case ConferenctStatusEnum.ongoing:
      return "进行中";
    case ConferenctStatusEnum.finished:
      return "已结束";
    case ConferenctStatusEnum.canceled:
      return "已取消";
    case ConferenctStatusEnum.expire:
      return "已过期";
    case ConferenctStatusEnum.invalid:
      return "已失效";
    default:
      return "";
  }
};

export interface ConferenceInterface {
  title: string; //  会议名称
  beginTime: string; //  开始时间  yyyy-MM-dd HH:mm:ss
  endTime: string; //  结束时间 yyyy-MM-dd HH:mm:ss
  allowEarlyEntry: BoolType; //  是否允许提前进入1是，0 否；默认1
  muteJoinMeeting: BoolType; //  成员加入会议静音，1是，0否；默认1
  playTips: BoolType; //  成员加入会议时播放提示音，1是，0否；默认0
  allowSelfUnmute: BoolType; //  允许成员自我解除静音，1是，0否，默认1
  passwordEnable: BoolType; //  是否开启入会密码，0否，1是，默认0
  password?: string; //  会议密码
  ownerPassword?: string; //  主持人密码
  useSelfConference: BoolType; //  是否使用个人会议号   1:是 0：否，默认0
  type: ConfefenctType; //  会议类型：1：预约会议   2：即时会议
  agendaId?: string; //议程id

  conferenceNo?: string; //会议号
  agenda?: string; //会议议程
  muteJoinMetting?: BoolType; // 成员加入会议静音，1是，0否，默认1
  links?: string; //会议链接
  ownerId?: string; //会议创建人
  ownerName?: string; //会议创建人名称
  agendaPermission?: string; //会议议程权限 0：所有人可见 1：仅主持人可见，默认1
  id?: number; //id  会议 记录的 ID
  allMuteState?: number; //全局的静音状态  0：全体解除静音  1：全体静音；默认0
  recordPermission?: number; //	录制权限    0：所有人可录制  1：仅主持人可录制；默认1
  sharePermission?: number; //共享权限 0：所有人可共享  1：仅主持人可共享；默认0
  lockedState?: BoolType; //锁定状态： 0未锁定；1锁定；默认0
  roomId: string; //rtc会议号
  status?: ConferenctStatusEnum; // 会议状态：0:未开始、10:进行中，20:已结束 、30:已取消 ，40：已过期 50:已失效
  duration?: number | string;
  "X-Conference-No"?: string;
  "X-Channel-Token"?: string;
  "X-Conference-Token"?: string;
  roleCode?: RoleCode;

  roleName?: string;
  roomid?: string;
  userId?: string;
  currHostUserId: string;
  attendList?: Array<ParticipantType>;
  isHostLeave?: boolean;
  /**
   * peerId: "114832208312501923_qzxugatsjokkbnf"
    raiseHandStatus: 0
    recordStatus: 0
    roleCode: 20
   */
}

export interface UserInfo {
  userId: string; //用户id
  email: string;
  phone: string;
  avatar: string;
  realName: string;
  enterpriseId: string;
  enterpriseName: string;
  conferenceNo: string;
  agendaPermission: BoolType; //会议议程权限: 0：所有人可见 1：仅主持人可见
  passwordEnable: BoolType; //是否开启入会密码:  0 关闭，默认；1 开启
  ownerPasswordEnable: BoolType; //是否开启个人会议号主持人密码  0 关闭，默认；1 开启
  ownerPassword: string;
  allowEarlyEntry: BoolType; //是否允许提前进入 1：是；0否；
  muteJoinMeeting: BoolType; //成员加入会议静音 1：是；0否；
  playTips: BoolType; //成员加入会议时播放提示因1：是；0否；
  allowSelfUnmute: BoolType; //允许成员自我解除静音;1是；0：否
  password: string; //会议密码
  usefulLife: number; //有效期
  thresholdValue: number; //参会人数上限个数
  packageType: BoolType; //套餐类型 1：免费版；2：企业版
  links: string; //个人会议邀请链接
  username: string;
  authRoles: Array<string>; //角色类型 0 .个人账号 1.主账号 2.子账号
  virtualNum: string; //虚拟号
}

export enum enumOpType {
  t_None = 0,
  t_CanvasItem = 1,
  t_RectItem = 2,
  t_TextItem = 3,
  t_EllipseItem = 4,
  t_ImageItem = 5,
  t_PathItem = 6,
  t_AudioItem = 7,
  t_TriangleItem = 8,
  t_LineItem = 9,
  t_ArrowLineItem = 10,
  t_XiangPiCa = 11,
  t_YingGuangBiItem = 12,
  t_End = 13,
}

export enum DrawToolType {
  Pencil = "pencil",
  Line = "line",
  Rectangle = "rectangle",
  Ellipse = "ellipse",
  Eraser = "eraser",
  Clear = "clear",
}

export enum BoardCommond {
  BoardOpen = 20,
  BoardData = 22,
  BoardClear = 23,
  BoardClose = 29,
}

/////  types of board..

export interface Point {
  x: number;
  y: number;
}

export interface PadItemType {
  id: string;
  tool: string;
  color: string;
  fill?: string;
  size: number;
  points?: Array<Point>;
  start?: Point;
  end?: Point;
  op?: string;
}

export interface ItemProp {
  [k: string]: any;
  id: string;
  op: string;
  data: any;
  get: (a: string) => any;
}

export interface ToolType {
  onMouseDown: (
    x: number,
    y: number,
    color: string,
    size: number,
    fill?: string
  ) => Array<PadItemType>;
  onMouseMove: (x: number, y: number) => Array<PadItemType>;
  onDebouncedMouseMove?: () => [PadItemType, Array<PadItemType>];
  onMouseUp: (x: number, y: number, tag?: boolean) => Array<PadItemType>;
  draw: (item: PadItemType, animate?: boolean) => Array<PadItemType>;
}

export interface SketchPadProp {
  width: number;
  height: number;
  animate?: boolean;
  canvasClassName: string;
  color: string;
  fillColor?: string;
  size: number;
  ptool: DrawToolType;
  onItemStart?: () => void; // function(stroke:Stroke) { ... }
  onEveryItemChange?: () => void; // function(idStroke:string, x:number, y:number) { ... }
  onDebouncedItemChange?: () => void; // function(idStroke, points:Point[]) { ... }
  onCompleteItem: (a: any) => void; // function(stroke:Stroke) { ... }
  debounceTime?: number;
  operation: string;
  items: Array<ItemProp>;
  scale?: number;
  remoteType?: REMOTE_OPERATION;
}

export interface RectType {
  xMin: number;
  xMax: number;
  yMin: number;
  yMax: number;
}

export enum REMOTE_OPERATION {
  INCREMENT = "increment",
  DECREMENT = "decrement",
}

export enum OPERATION_TYPE {
  SELECT = "select",
  DRAW_LINE = "line",
  DRAW_SHAPE = "shape",
  CLEAR = "clear",
  CLEAR_ALL = "clear_all",
  INSERT_PIC = "insert_pic",
  TEXT = "text",
  DROP_PIC = "drop_pic",
  UNDO = "undo",
  REDO = "redo",
  MOVE = "move",
  DRAG = "drag",
}

export const CURSOR_MAP = {
  SELECT: "select",
  PENCIL: "pencil",
  RECT: "rect",
};

export type LineType =
  | "select"
  | "stroke"
  | "pen"
  | "straight"
  | "shape"
  | "color"
  | "text"
  | "rubber"
  | "import"
  | "undo"
  | "redo"
  | "amp"
  | "save"
  | "locked"
  | "unlock"
  | "eye";

export enum ShowLayout {
  Gallery = "gallery",
  Speaker = "speaker",
  Thumbnail = "thumbnail",
  Side = "side",
}
